var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('ModalContainer'),_vm._v(" "),_c('Transition',{attrs:{"name":"search"}},[(_vm.$store.getters['search/active'])?_c('SearchForm'):_vm._e()],1),_vm._v(" "),_c('Drawer'),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }